<template>
  <v-app v-if="!userDetails.IsFirstTime && !layout.skipFirstTime">
    <pwa-update/>
    <modals-container/>
    <modal name="loading" classes="modal" :clickToClose="false" height="100%" width="100%">
      <loading/>
    </modal>
    <modal name="error" classes="modal" :clickToClose="false" height="100%" width="100%">
      <error/>
    </modal>
    <v-app-bar
        v-if="!$route.meta.noMenu && !isMobile"
        :color="colors.AppbarColor"
        :dark="colors.IsAppbarDark"
        app
    >
      <v-container class="d-flex align-center" style="max-width: 1500px">
        <v-app-bar-nav-icon v-if="!userDetails.AltTiSi.IsProjectFromQRCode"
                            @click.stop="showSidebar = !showSidebar"></v-app-bar-nav-icon>
        <v-btn icon @click.stop="goBack()" v-if="!$route.meta.noBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title class="font-weight-bold" style="font-size: 24px">
          <portal-target name="toolbar-title"/>
        </v-toolbar-title>
        <v-toolbar-items class="ml-6">
          <portal-target name="toolbar-items"/>
        </v-toolbar-items>
        <v-spacer/>
        <portal-target name="toolbar-actions"/>
        <v-menu>
          <template v-slot:activator="{on,attrs}">
            <v-badge overlap offset-x="15" offset-y="15"
                     :color="ongoingCallouts.length?'callout':'secondary'"
                     :content="''+ongoingCallouts.length">
              <v-avatar v-ripple style="border:solid 1px;" color="#11111123" v-on="on" v-bind="attrs">
                <v-icon>mdi-alert-outline
                </v-icon>
              </v-avatar>
            </v-badge>
          </template>
          <open-callouts/>
        </v-menu>
      </v-container>
    </v-app-bar>

    <v-app-bar
        :color="colors.AppbarColor"
        :dark="colors.IsAppbarDark"
        v-if="isMobile && !$route.meta.noMenu && userDetails.Subscription "
        app
    >
      <v-btn icon @click.stop="goBack()" v-if="!$route.meta.noBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>
        <h5>
          <portal-target name="toolbar-title"/>
        </h5>
      </v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items class="ml-6">
        <portal-target name="toolbar-items"/>
      </v-toolbar-items>
      <portal-target name="toolbar-actions"/>
      <portal-target name="toolbar-before-title"/>
      <v-app-bar-nav-icon v-if="!userDetails.AltTiSi.IsProjectFromQRCode" @click.stop="showSidebar = !showSidebar"/>
    </v-app-bar>
    <v-navigation-drawer
        :color="colors.SidebarColor"
        class="elevation-5"
        v-if="userDetails.Subscription && !userDetails.AltTiSi.IsProjectFromQRCode"
        v-model="showSidebar"
        left
        :dark="colors.IsSidebarDark"
        mobile-breakpoint="760"
        app>
      <v-toolbar flat :color="colors.BrandBackgroundColor" light max-height="200">
        <domain-image height="55"></domain-image>
      </v-toolbar>
      <v-divider></v-divider>
      <v-list nav>
        <v-list-item dense>
          <v-list-item-content>
            <v-list-item-title>
              {{ userDetails.Username }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ userDetails.Fullname }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn small text v-tooltip="'Αποσύνδεση'" @click="logout()">
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-divider/>
      <sidebar-menu/>
      <v-footer absolute>
        <img width="75" src="@/assets/winlift-managers.png"/>
      </v-footer>
    </v-navigation-drawer>

    <v-main class="background">
      <page>
        <router-view/>
      </page>
      <portal to="footer-content">
        <office-info-footer></office-info-footer>
      </portal>
      <div v-if="isMobile" style="padding-bottom: 50px"/>
    </v-main>
    <v-bottom-navigation
        v-if="isMobile && userDetails.Subscription && !userDetails.AltTiSi.IsProjectFromQRCode"
        fixed
        grow
        color="light"
        :background-color="colors.SidebarColor"
        :dark="colors.IsSidebarDark"
    >
      <v-btn to="/">
        <span>Αρχική</span>
        <v-icon :color="colors.SidebarIconsColor">mdi-home</v-icon>
      </v-btn>

      <v-btn v-if="userDetails.Allows.ShowCallouts" to="/history">
        <span>Εργασίες</span>
        <v-icon :color="colors.SidebarIconsColor">mdi-history</v-icon>
      </v-btn>

      <v-btn to="/issues" v-if="userDetails.Allows.AddIssues">
        <span>Αιτήματα</span>
        <v-icon :color="colors.SidebarIconsColor">mdi-email</v-icon>
      </v-btn>
      <v-btn @click="goToLifts()">
        <span>Ανυψ.</span>
        <v-icon :color="colors.SidebarIconsColor">mdi-elevator</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
  <v-app v-else>
    <v-content class="background">
      <v-container class="" style="max-width: 700px">
        <v-card class="mb-4">
          <v-list nav>
            <v-list-item dense>
              <v-list-item-action>
                <v-icon>mdi-account</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ userDetails.Username }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ userDetails.FullName }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item dense color="red" @click="logout()">
              <v-list-item-action>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                Αποσύνδεση
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <change-password :show-alert="true"/>
      </v-container>
    </v-content>

  </v-app>

</template>

<script>
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'
import Loading from "./wl-core/components/Loading";
import SidebarMenu from "./components/templates/SidebarMenu";
import ChangePassword from "./components/ChangePassword";
import Error from "./wl-core/components/Error";
import OpenCallouts from "./views/Events/components/OpenCallouts";
import PwaUpdate from "./wl-core/components/PwaUpdate";
import Page from "@/components/templates/Page";
import OfficeInfoFooter from "@/components/OfficeInfoFooter.vue";
import InstallButton from "./components/InstallButton.vue";
import DomainImage from "@/components/DomainImage";

export default {
  name: 'App',

  components: {
    DomainImage,
    InstallButton,
    OfficeInfoFooter,
    Page,
    PwaUpdate,
    OpenCallouts,
    Error,
    ChangePassword,
    SidebarMenu,
    Loading,
  },
  computed: {
    ...mapState([
      'subdomain'
    ]),
    ...mapGetters([
      'layout',
      "colors",
      'projects',
      'Subscription',
      'userDetails',
      'branches',
      'openDepts',
      "loading",
      "error",
      "isMobile",
      "ongoingCallouts"
    ])
  },
  data: () => ({
    showSidebar: null
  }),

  //on route change
  watch: {
    $route(to, from) {
      if (this.isMobile) {
        this.showSidebar = false
        window.scroll(0, 0)
      }
    },
    loading: function (val) {
      if (val) {
        this.$modal.show('loading')
      } else {
        this.$modal.hide('loading')
      }
    },
    error: function (val) {
      if (val) {
        this.$modal.show('error')
      } else {
        this.$modal.hide('error')
      }
    }
  },
  updated() {
    this.checkMobile();
  },

  mounted() {
    this.checkMobile();
    history.pushState({}, "");

  },
  methods: {
    goToLifts() {
      if (this.projects.length === 1) {

        this.$router.push('/lift/' + this.projects[0].Project_ID)
      } else {
        this.$router.push('/lifts')
      }
    },
    ...mapActions([
      "init",
      "logout",
      "getOpenIssues",
      "getOpenDepts",
      "getOngoingCallouts",
      "getPartnerDetails",
      "getRecentMaintenances"

    ]),
    ...mapMutations([
      "setCalloutLoading",
      "setOpenDeptsLoading",
      "setOpenIssuesLoading",
      "setMaintenancesLoading",
      "setMobile",
      "setfirebaseMessaging",
    ]),
    checkMobile() {
      if (window.innerWidth <= 1200) {
        this.setMobile(true)
      } else {
        this.setMobile(false)
      }
    },
    goBack() {
      window.history.back();

    }
  }
};
</script>

<style>


</style>

